import React, { useContext, useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useParams } from 'react-router-dom';
import SettlementController from '../../controller/SettlementController';
import { nanoid } from 'nanoid';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';
import { useNavigate } from 'react-router-dom';
import DeliveryController from '../../controller/DeliveryController';
import toast from 'react-hot-toast';
import { DELIVERY_POINTS, DELIVERY_WITHDRAW_MIN } from '../../utils/DataType';

const DeliveryManDelivery = (oProps: any) => {
  const [bButtonEnabled, set_bButtonEnabled] = useState<boolean>(false);
  const [oOrderStatus, set_oOrderStatus] = useState<number>(0);
  const [sUUid, set_sUUid] = useState<string>("");
  const [oOrderData, set_oOrderData] = useState<any>("");
  const [iCurrentPoints, set_iCurrentPoints] = useState<number>(0);
  const navigate = useNavigate();
  let oParams = useParams();

  const GlobalStyle = createGlobalStyle`
    html, body, #root, #root > div {
      height: 100%
    }
  `
  const getOrderByOrderId = async () => {
    try {
      if (oParams && oParams.order_id) {
        const oData = {
          order_id: oParams.order_id,
        };
        const response = await SettlementController.getOrderByOrderId(oData);

        if (response.data.ok) {
          //console.log('response.data.data', response.data.data);
          let oOrderData = response.data.data.order.child[0];
          set_oOrderStatus(oOrderData.order_status);
          set_oOrderData(response.data.data.order);
          console.log('response.data.data.order', response.data.data.order);
        } else {
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const getPoints = async (sUUidValue: string) => {
    try {
      const response = await DeliveryController.getDeliveryPoint(sUUidValue);

      if (response.data.ok) {
        if (response.data.data) {
          set_iCurrentPoints(response.data.data.point);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  }

  const initUuid = async () => {
    let sUuid = await AsyncLocalStorage.getItem('uuid');
    if (sUuid) {
      set_sUUid(sUuid);
    } else {
      let sNewUuid = nanoid();
      await AsyncLocalStorage.setItem('uuid', sNewUuid);
      set_sUUid(sNewUuid);
    }
    getOrderByOrderId();
  }

  const updateOrderDelivery = async (iOrderStatus: number) => {
    try {
      let sOrderId = oParams.order_id;
      let sOrderSeq: any = oParams.order_seq || 0;
      if (sOrderId) {
        const response = await DeliveryController.updateOrderStatus({
          order_status: iOrderStatus,
          order_id: sOrderId,
          device_uuid: sUUid,
          order_seq: sOrderSeq
        });

        if (response.data.ok) {
          set_oOrderStatus(iOrderStatus);
        } else {
          toast.error(response.data.msg);
        }
      }

    } catch (err) {
      console.log('err-->', err);
    }

  }

  useEffect(() => {
    console.log('DeliveryManDelivery oProps', oProps);
    console.log('oParams', oParams);
    initUuid();

    return () => {
    };
  }, []);

  useEffect(() => {
    if (oOrderStatus) {
      if (oOrderStatus === 7) {
        let sOrderId = oParams.order_id;
        let sOrderSeq = oParams.order_seq;
        navigate(`/order/accumulate/${sOrderId}/${sOrderSeq}`);
      }
    }

    return () => {
    };
  }, [oOrderStatus]);

  useEffect(() => {
    if (sUUid) {
      getPoints(sUUid);
    }

    return () => {
    };
  }, [sUUid]);

  return (
    <Style>
      <>
        <GlobalStyle />
        <div className="content">
          <img src={`${process.env.PUBLIC_URL}/img/knock_logo.png`} width="14%" alt="logo" />
          {(oOrderStatus === 1 || oOrderStatus === 2) &&
            <>
              <div className="textContent">
                <h1><span className="pickupFont">픽업</span>을 완료하셨나요?{`\n안전하고 빠른 배달\n부탁드려요 🙏`}</h1>
                <h3>
                  {`노크노크 주문을 수행하고\n`}(<span className="pickup">픽업 후, 배달완료 후</span>)
                  {`\n버튼을 눌러주시면 응원지원금을 드려요!`}
                </h3>
              </div>
              <div className="spacer"></div>
              <h3>
                {`현재 보유하신 응원지원금은\n`}
                <span className={`pickupFont pointFont`}>{`${iCurrentPoints.toLocaleString()}P`}</span>{` 입니다`}
              </h3>
              <div className="footer">
                <div className="box">
                  <h4>- 배달 1건당 {DELIVERY_POINTS}포인트씩 쌓여요 💰</h4>
                  <h4>- 현금으로 출금 가능해요 💸</h4>
                </div>
                <button className={`pickup`} onClick={() => updateOrderDelivery(6)}>
                  <h1>픽업 완료</h1>
                </button>
              </div>
            </>
          }

          {oOrderStatus === 6 &&
            <>
              <h1><span className="deliveryFont">배달</span>을 완료하셨나요?{`\n오늘도 수고하셨습니다 👏`}</h1>
              <h3>
                {`배달 완료 버튼 누르고\n`}
                <span className="delivery">응원지원금</span> 받아가세요!
              </h3>
              <div className="spacer"></div>
              <h3>
                {`현재 보유하신 응원지원금은\n`}
                <span className={`deliveryFont pointFont`}>{`${iCurrentPoints.toLocaleString()}P`}</span>{` 입니다`}
              </h3>
              <div className="footer">
                <div className="box">
                  <h4>- {DELIVERY_WITHDRAW_MIN.toLocaleString()}원 이상부터 현금으로 출금 가능해요 💸</h4>
                  <h4>- 배달 1건당 {DELIVERY_POINTS}포인트씩 쌓여요 💰</h4>
                  <h4>- 현금으로 출금 가능해요 💸</h4>
                </div>
                <button className={`delivery`} onClick={() => updateOrderDelivery(7)}>
                  <h1>배달 완료</h1>
                  <h3>누르고 {DELIVERY_POINTS}P 받기</h3>
                </button>
              </div>
            </>
          }

          {oOrderStatus === 4 &&
            <>
              <h1>주문이{'\n'}<span className="pickupFont">취소</span>되었어요😭</h1>
              <h3>
                {`주문 취소가 완료되었습니다\n문의사항이 있다면\n매장으로 연락주세요`}
              </h3>
              <div className="spacer"></div>
              <div className="footer">
                {oOrderData.store_name &&
                  <div className="box">
                    <h4>{oOrderData.store_name}</h4>
                    <h4>{oOrderData?.child[0].store_phone_number} 📞</h4>
                  </div>
                }
              </div>
            </>
          }

        </div>
      </>
    </Style >
  );
};
export default DeliveryManDelivery;

export const Style = styled.div`
  .pickupFont {
    color: #4dd2ae;
  }
  .deliveryFont {
    color: #ff8d23;
  }
  .pointFont {
    font-size: 32px; font-weight: 700;
  }

  .content {
    position: relative;
    /*width: 100%;*/
    height: 100%;
    text-align: left;
    padding: 10px;
    background: #ffffff;
    white-space: pre-line;
    display: flex;
    flex-direction: column;
    flex:1;
  }
  .textContent {
  }
  img {
    padding-bottom:30px;
  }
  p {
    font-size: 14px;
    line-height: 14px;
    font-weight: 300;
    color: #000000;
    margin: 0;
  }
  h1 {
    font-size: 28px;
    line-height: 40px;
    color: #555555;
    font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;
    font-weight: 600;
    margin-bottom: 20px;
  }
  h3 {
    line-height: 30px;
    color: #555555;
    font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;
    margin: 0;
    font-weight: 500;
    span.delivery {
      background: #ffdcbb;
    }
    span.pickup {
      background: #d3f7ed;
    }
    span.point {
      font-size: 32px;
      line-height: 36px;
      background: none;
      font-weight: 700;
    }
  }
  .spacer {
    flex:1
  }
  .gap {
    margin-top: 6%;
  }
  .footer {
    /*width: calc(100% - 20px);
    position: fixed;
    bottom: 10px;
    display: flex;
    flex-direction: column;*/
    padding-top: 10px;
  }
  .box {
    background: #f6f6f6;
    border-radius: 10px;
    padding: 16px;
  }
  .box h4 {
    font-size: 16px;
    line-height: 30px;
    color: #979797;
    font-weight: 500;
    margin: 0;
  }
  button {
    margin-top: 12px;
    width: 100%;
    height: 14vh;
    background: #ff8d23;
    border: none;
    border-radius: 5px;
    min-height: 120px;
  }
  button.pickup {
    background: #4dd2ae;
  }
  button.delivery {
    background: #ff8d23;
  }
  button h1 {
    font-weight: 600;
    margin: 0;
    color: #ffffff;
  }
  button h3 {
    font-weight: 500;
    color: #ffffff;
  }
`;
